import { useTranslation } from 'react-i18next';

import { IngredientTabProps } from 'components/desktop/Ingredient/IngredientComponent';
import FoldableCard from 'components/desktop/_general/Card/FoldableCard/FoldableCard';
import TreeInput from 'components/desktop/_general/Input/TreeInput/TreeInput';
import PERMISSIONS from 'enums/permissions';
import { arePermissionsInUserPermissions } from 'functions/tokenFunctions';
import * as IngredientCategoryList from 'types/_general/Store/IngredientCategoryList';

export const IngredientCategoryCard = ({
	state,
	handlers,
	data,
}: IngredientTabProps): JSX.Element => {
	const { t } = useTranslation();

	const isIngredientEditor: boolean = arePermissionsInUserPermissions([
		PERMISSIONS.WRITEINGREDIENT,
	]);
	const getLabelCategories = (): string => {
		if (isIngredientEditor) return '';
		if (state.categoryIds.length !== 0) return '';
		return t('ingredient:NO_CATEGORIES');
	};

	return (
		<FoldableCard
			defaultOpen={true}
			dataComponentType="ingredient-categories-card"
			title={t('ingredient:CATEGORIES')}
			content={
				<>
					<div className="card-body">
						<TreeInput
							input={data.categories}
							setSelected={handlers.setCategories}
							selected={IngredientCategoryList.getFromIds(
								data.categories,
								state.categoryIds
							)}
							errorKey={'Categories'}
							disabled={!isIngredientEditor}
							label={getLabelCategories()}
							noObjectsFoundText={t('_general:NO_CATEGORIES')}
						/>
					</div>
				</>
			}
		/>
	);
};
